export const USER_SERVICE_KEY = 'user';
export const USER_STORE_KEY = 'user';
export const USER_API_URL = '/api/v1/user/';
export const UPDATE_PASSWORD_URL = '/api/v1/user/update-password/';
export const PENDING_INVITES_URL = '/api/v1/user/pending-invites/';
